import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  actions: {
    async getUserById ({ state }, userId) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/users/' + userId)).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async getUserByEndpoint ({ state }, options) {
      return (await Vue.http.post(this.state.baseUrl + '/users/byendpoint', options)).data
    },
    async getUserByUsername ({ state }, username) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/users/byusername/' + username)).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async getUserDetails ({ state, commit }, userId) {
      let data = (await Vue.http.get(this.state.baseUrl + '/users/' + userId)).data
      commit('setState', {
        stateName: 'userDetails',
        stateValue: data
      })
      return data
    },
    async getDoctorsBySpeciality ({ state }, options) {
      let queryArr = []
      if (options.gender) {
        queryArr.push('gender=' + options.gender)
      }
      if (options.availableFor) {
        queryArr.push('availableFor=' + options.availableFor)
      }
      if (options.location) {
        queryArr.push('location=' + options.location)
      }
      if (options.speciality) {
        queryArr.push('speciality=' + options.speciality)
      }
      let query = queryArr.join('&')
      return (await Vue.http.get(this.state.baseUrl + '/providers/bySpeciality/' + options.specialityId + '?' + query)).data
    },
    async getDoctor ({ }, doctorId) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/users/doctor/' + doctorId)).data
      } catch (e) {
        console.log(e)
        throw (e)
      }
    },
    async getOnlineDoctorsBySpeciality ({ state }, specialityId) {
      return (await Vue.http.get(this.state.baseUrl + '/providers/bySpeciality/_online/' + specialityId)).data
    },
    async getTelemedDoctorsBySpeciality ({ state }, options) {
      try {
        let user = JSON.parse(localStorage.user);
        return (await Vue.http.post(this.state.baseUrl + '/directtelemedicine/providers/_bySpeciality?pageNumber=' + options.pageNumber, {
          tenant: user.tenant.name || 'default',
          specialityId: options.selectedSpecialityId
        })).data
      } catch (e) {
        console.log(e)
        return []
      }
    },
    async updateUser ({ state }, user) {
      return (await Vue.http.put(this.state.baseUrl + '/users/' + user._id, user)).data
    },
    async updateAvailibility ({ state }, options) {
      return (await Vue.http.put(this.state.baseUrl + '/users/updateavailibility/' + options._id, options)).data
    },

    //Update profileImage and signatureImage
    async updateUserProfile ({ state }, options) {
      return (await Vue.http.put(this.state.baseUrl + '/users/app/' + options._id, options)).data
    },
    async saveSlots ({ state }, slots) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/slots', slots)).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async getSlots ({ state }, userId) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/slots/byusers/' + userId)).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async deleteSlot ({ state }, slotId) {
      try {
        return (await Vue.http.delete(this.state.baseUrl + '/slots/' + slotId)).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async deleteRecurringSlots ({ state }, seriesId) {
      return (await Vue.http.delete(this.state.baseUrl + '/slots/reccurring/' + seriesId)).data
    },
    async updateSlot ({ state }, slot) {
      try {
        return (await Vue.http.put(this.state.baseUrl + '/slots/' + slot.slotId, slot)).data
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async getProvidersByAssociation ({ state }, options) {
      return (await Vue.http.post(this.state.baseUrl + '/users/byassociation', options)).data
    },
    async addMyDoctor ({ state }, options) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/users/addmydoctor/' + options.userId, { doctorId: options.doctorId })).data
      } catch (e) {
        throw e
      }
    },
    async addConsent ({ state }, options) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/users/addconsent/' + options.userId, options)).data
      } catch (e) {
        throw e
      }
    },
    async removeMyDoctor ({ state }, options) {
      try {
        return (await Vue.http.post(this.state.baseUrl + '/users/removemydoctor/' + options.userId, { doctorId: options.doctorId })).data
      } catch (e) {
        throw e
      }
    },
    async getPreviousAppointmentDoctors ({ state }, options) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/users/doctors/previousappointment/' + options.userId)).data
      } catch (e) {
        throw e
      }
    },
    async getSignedConsents ({ state }, options) {
      try {
        return (await Vue.http.get(this.state.baseUrl + '/users/consents/' + options.userId)).data
      } catch (e) {
        throw e
      }
    },
  }
}
